import api from "../Utils/axios";

export const getNotifications = (page, perPage, filter) => {
  return api.get(`/notification/get`, {
    params: {
      page,
      limit: perPage,
      ...(filter && filter !== "all" ? { filter } : {}),
    },
  });
};

export const getUnreadNotificationCount = () => {
  return api.get(`/notification/notifications/unreadCount`);
};

export const markNotificationAsRead = (notificationId) => {
  return api.post(`/notification/markRead`, null, { params: { id: notificationId } });
};

export const markAllNotificationsAsRead = () => {
    return api.post(`/notification/markAllRead`);
};

export const sendBroadcastNotification = (data) => {
    return api.post(`/notification/send`, data);
};

export const getAdminLogs = (page, perPage, from, to) => {
    return api.get(`/notification/admin-logs`, {
        params: {
            page,
            limit: perPage,
            ...(from ? { from } : {}),
            ...(to ? { to } : {})
        }
    });
};

export const resendCampaignNotification = (id) => {
    return api.post(`/notification/resend`, { id });
};

export const deleteCampaignNotification = (id) => {
    return api.post(`/notification/delete`, { id });
};
